
(function(){
const root = document.querySelector("[data-corvia-quiz-v2]");
if (!root || root.dataset.initialized === "true") return;
root.dataset.initialized = "true";
const PRODUCT_URL = root.dataset.productUrl || "https://trycorvia.com/products/corvia-heart-longevity%E2%84%A2-90-day-program";
const PRIVACY_URL = root.dataset.privacyUrl || "https://trycorvia.com/pages/privacy-policy";
const KLAVIYO_PUBLIC_KEY = (root.dataset.klaviyoPublicKey || "").trim();
const KLAVIYO_LIST_ID = (root.dataset.klaviyoListId || "").trim();
// Consio is connected to Klaviyo from Consio Settings > Integrations.
// Do not put a Consio API key in this browser-side quiz. Consio reads the
// dedicated Klaviyo segment configured from Heart_Check_Lead / phone_number.

const A = {};
const CHEST = "Chest pain, pressure or tightness";             // answers by step id
let lead = {name:"", email:"", phone:""};
let i = 0, hist = [];
let quizStartedAt = null;
let quizCompletedAt = null;
let klaviyoQueue = Promise.resolve();
let klaviyoSubscriptionComplete = false;


const S = [
 {id:"age", type:"single", hook:true,
  q:"How old are you?",
  opts:["Under 40","40–49","50–59","60–69","70 or older"]},

 {id:"concerns", type:"multi",
  q:"What worries you most about your heart right now?", sub:"Choose as many as you like",
  opts:["My blood pressure numbers are creeping up","My cholesterol is high or borderline","Low energy and afternoon crashes","Cold hands and feet, poor circulation","I tire out faster than I used to","Chest pain, pressure or tightness","Heart problems run in my family","Nothing yet. I want to stay ahead of it"], none:"Nothing yet. I want to stay ahead of it"},

 {id:"gate", type:"gate"},

 {id:"severity", type:"single",
  q:"How noticeable has it become?",
  opts:[["Just starting","I notice it, but nobody else would"],["Clearly there","My doctor or family has mentioned it"],["Hard to ignore","I've started holding back from things I used to do"]]},

 {id:"signs", type:"multi",
  q:"Which of these show up in your week?", sub:"Choose all that apply",
  opts:["Afternoon energy crash","Winded on stairs or long walks","Cold hands or feet","Slow to recover after activity","Short or restless sleep","None of these"], none:"None of these"},

 {id:"rightplace", type:"info", render:()=>`
   <h2>You're in the right place.</h2>
   <p class="sub" style="margin:0">Most people over 40 wait for a doctor's visit or a scare before they think about their heart. You're starting with a plan.</p>
   <div class="card stack">
     <div class="ok">CORVIA supports the four connected pathways behind heart longevity: healthy blood pressure, blood flow, arterial function and cellular energy.</div>
     <div class="ok">Every bottle comes with the 90-Day Heart Longevity Program, so you get a capsule and a strategy.</div>
   </div>`, cta:"Continue"},

 {id:"family", type:"single",
  q:"Has anyone in your family had heart trouble?",
  sub:"Heart attack, stroke, high blood pressure or heart surgery",
  opts:["Yes, a parent","Yes, a grandparent","Yes, a brother or sister","Yes, more than one person","No","I'm not sure"]},

 {id:"meds", type:"single",
  q:"Do you take any of these right now?",
  opts:[["A blood thinner","Warfarin, Eliquis, Xarelto, Plavix or daily aspirin"],["Blood pressure medication",""],["Both",""],["None of these",""],["I'm not sure",""]]},

 {id:"activity", type:"single",
  q:"How active are you in a typical week?",
  opts:[["Very active","Exercise or long walks most days"],["Somewhat active","A few walks or workouts"],["Mostly sitting","Desk, car and couch most days"],["I'm not sure",""]]},

 {id:"stress", type:"single",
  q:"I feel the pressure of stress…",
  opts:["Every day, constantly","Most days, especially at work","Mainly during busy periods","I rarely feel stressed"]},

 {id:"fit", type:"info", render:()=>{
   const m = A.meds;
   if (m==="A blood thinner" || m==="Both") return `
     <h2>Good news: your plan still works for you.</h2>
     <p class="sub" style="margin:0">You're one step away from your Heart Longevity Profile. Your FREE 90-Day Heart Longevity Program gives you simple daily nutrition, movement, sleep and stress actions you can start right away and share with your doctor.</p>`;
   return `
     <h2>Congratulations, you're a great fit.</h2>
     <div class="card stack">
       <div class="ok">One capsule a day. Six ingredients, no proprietary blend.</div>
       <div class="ok">Third-party tested and made in the USA.</div>
       <div class="ok">Protected by a 90-day money-back guarantee.</div>
     </div>
     ${m==="Blood pressure medication" || m==="I'm not sure" ? `<div class="note"><b>Quick tip:</b> since you take medication or aren't sure, let your doctor know you're adding a supplement. It's a good habit with any new product.</div>`:""}`;
 }, cta:"Continue"},

 {id:"build", type:"loader", title:"Building your Heart Longevity Profile…",
  lines:["Reviewing your answers","Weighing lifestyle and family factors","Matching your heart support priority"]},

 {id:"profile", type:"profile"},

 {id:"tried", type:"multi",
  q:"What have you tried for your heart so far?", sub:"Choose all that apply",
  opts:["Fish oil or omega-3","CoQ10 on its own","Garlic or beet supplements","Changing my diet or exercise","Prescription medication","Nothing yet"], none:"Nothing yet"},

 {id:"why", type:"info", render:()=>`
   <h2>Why most heart supplements fall short</h2>
   <p class="sub" style="margin:0">Most give you one ingredient for one pathway. Your heart depends on several working together.</p>
   <div class="vs">
     <div class="col them"><h3>Typical supplement</h3><ul><li>One ingredient</li><li>One pathway</li><li>No plan for habits</li></ul></div>
     <div class="col us"><h3>CORVIA</h3><ul><li>Six ingredients in one capsule</li><li>Four pathways supported</li><li>90-Day Program included</li></ul></div>
   </div>
   <div class="ing">
     <div><b>Aged garlic extract</b><span>Arterial health</span></div>
     <div><b>Beetroot nitrates</b><span>Blood flow</span></div>
     <div><b>Cocoa flavanols</b><span>Circulation</span></div>
     <div><b>Ubiquinol (CoQ10)</b><span>Cellular energy</span></div>
     <div><b>Astaxanthin</b><span>Antioxidant support</span></div>
     <div><b>Nattokinase</b><span>Healthy circulation</span></div>
   </div>`, cta:"Continue"},

 {id:"time", type:"single",
  q:"How much time can you give your heart each day?",
  opts:["30 seconds","5 minutes","15 minutes","30 minutes or more","I'm not sure"]},

 {id:"busy", type:"auto", render:()=>`
   <h2>A busy schedule doesn't have to stop you.</h2>
   <p class="sub" style="margin:0">The capsule takes 30 seconds. The 90-Day Program gives you simple daily actions you can fit around ${A.time==="30 seconds"?"a packed day":"your routine"}.</p>
   <div class="loader" style="padding-top:8px"><div class="track"><i id="autobar"></i></div><div class="fine" style="text-align:left">Loading next question…</div></div>`},

 {id:"worry", type:"single",
  q:"Have you ever worried your heart won't keep up with the life you want to live?",
  opts:["Yes","Sometimes","No"]},

 {id:"meaning", type:"single",
  q:"What would a stronger heart mean to you?",
  opts:["Keeping up with my kids or grandkids","Not dreading my next blood pressure check","Being around for the people who count on me","Staying active and independent as I age","All of the above"]},

 {id:"event", type:"single",
  q:"Is there something coming up you want to feel your best for?",
  opts:["A wedding or family celebration","A trip or vacation","Retirement","My next doctor's checkup","Nothing specific. I want to start now"]},

 {id:"eventDate", type:"date", when:()=>A.event && !A.event.startsWith("Nothing"),
  q:"When is it?", sub:"We'll build your plan around this date."},

 {id:"plan", type:"plan"}
];

const app = root.querySelector(".app");
const backBtn = root.querySelector(".back");
const progEl = root.querySelector(".progress-fill");
const esc = s => String(s).replace(/[&<>"']/g, c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
const first = () => (lead.name||"").trim().split(/\s+/)[0] || "";

function visible(idx){ const s=S[idx]; return !s.when || s.when(); }
function nextIdx(from){ let n=from+1; while(n<S.length && !visible(n)) n++; return n; }

function go(n, push=true){
  if (n>=S.length) return;
  if (push) hist.push(i);
  i=n; render();
  window.scrollTo({top:0, behavior:"auto"});
}
function next(){
  // Once the lead has been captured, save the latest answers before moving on.
  // The gate performs its own first save immediately after valid contact details are submitted.
  if (S[i].type !== "gate" && S[i].type !== "plan") {
    queueKlaviyoSave("in_progress");
  }
  go(nextIdx(i));
}
backBtn.addEventListener("click",()=>{
  // skip back over auto/loader screens
  let p = hist.pop();
  while (p!==undefined && ["loader","auto"].includes(S[p].type)) p = hist.pop();
  if (p===undefined) return;
  go(p,false);
});

function setProgress(){
  const pct = Math.round((i/(S.length-1))*100);
  progEl.style.width = Math.max(4,pct)+"%";
  const t = S[i].type;
  backBtn.disabled = hist.length===0 || ["loader","auto"].includes(t);
}

let timer = null;
function render(){
  clearTimeout(timer);
  const s = S[i];
  setProgress();
  let h = "";
  if (s.type==="single" || s.type==="multi") h = renderQuestion(s);
  else if (s.type==="info") h = s.render() + `<button class="btn" id="cta">${s.cta}</button>`;
  else if (s.type==="auto") h = s.render();
  else if (s.type==="gate") h = renderGate();
  else if (s.type==="loader") h = renderLoader(s);
  else if (s.type==="profile") h = renderProfile();
  else if (s.type==="date") h = renderDate(s);
  else if (s.type==="plan") h = renderPlan();
  app.innerHTML = `<section class="screen">${h}</section>`;
  wire(s);
  // Save the calculated result as soon as the customer reaches the profile screen.
  if (s.type === "profile") queueKlaviyoSave("result_ready");
  // Save the complete quiz and final result when the plan screen is reached.
  if (s.type === "plan") queueKlaviyoSave("completed");
  const hd = app.querySelector("h1,h2"); if (hd){ hd.setAttribute("tabindex","-1"); }
}

function renderQuestion(s){
  const multi = s.type==="multi";
  const cur = A[s.id] || (multi?[]:null);
  const top = s.hook ? `<div class="banner">Take this 1-minute Heart Check to reveal <b>your Heart Longevity Profile</b> and unlock your <b>FREE 90-Day Heart Longevity Program</b></div>` : "";
  const opts = s.opts.map((o,k)=>{
    const [t,d] = Array.isArray(o)?o:[o,""];
    const on = multi ? cur.includes(t) : cur===t;
    return `<button class="opt${multi?" multi":""}" data-v="${esc(t)}" aria-pressed="${on}"><span class="mk">${on?"✓":""}</span><span class="t"><strong>${esc(t)}</strong>${d?`<small>${esc(d)}</small>`:""}</span></button>`;
  }).join("");
  return `${top}<h${s.hook?1:2}>${esc(s.q)}</h${s.hook?1:2}>${s.sub?`<p class="sub">${esc(s.sub)}</p>`:""}
    <div class="opts" role="group">${opts}</div>
    ${multi?`<button class="btn" id="cta" ${cur.length?"":"disabled"}>Continue</button>`:""}
    ${s.hook?`<p class="fine">Takes about 60 seconds. Your answers stay private.</p>`:""}`;
}

function renderGate(){
  return `<div class="kicker">Great start</div>
    <h2>Where should we send your Heart Longevity Profile?</h2>
    <p class="important"><b>IMPORTANT:</b> Your results are just a few questions away. To unlock your <u>FREE</u> 90-Day Heart Longevity Program, a CORVIA coach will call you personally to set up your access. Just enter your best phone number below.</p>
    <form id="gf" class="stack" novalidate>
      <label class="f" for="gname">First name<input id="gname" name="name" autocomplete="given-name" value="${esc(lead.name)}" placeholder="Your first name"></label>
      <label class="f" for="gemail">Email<input id="gemail" name="email" type="email" inputmode="email" autocomplete="email" value="${esc(lead.email)}" placeholder="you@example.com"></label>
      <label class="f" for="gphone">Mobile phone<input id="gphone" name="phone" type="tel" inputmode="numeric" pattern="[0-9]{10}" maxlength="10" autocomplete="tel" value="${esc(lead.phone)}" placeholder="e.g. 2125550100" required><small>Enter 10 digits only. Your US number will be formatted automatically before it is saved.</small></label>
      <div class="err" id="gerr" role="alert"></div>
      <button class="btn" type="submit">Continue to my results</button>
    </form>
    <p class="fine">By continuing you agree that CORVIA may email, call and text you at the number provided about your profile and offers, including by automated means. Consent is not a condition of purchase. Msg &amp; data rates may apply. Reply STOP to opt out. <a href="${PRIVACY_URL}" target="_blank" rel="noopener">Privacy Policy</a></p>`;
}

function renderLoader(s){
  return `<div class="loader"><h2>${esc(s.title)}</h2><div class="track"><i id="lbar"></i></div>
    <div class="lsteps">${s.lines.map(l=>`<div>${esc(l)}</div>`).join("")}</div></div>`;
}

function renderDate(s){
  const today = new Date(); const min = today.toISOString().slice(0,10);
  return `<h2>${esc(s.q)}</h2><p class="sub">${esc(s.sub)}</p>
    <label class="f" for="edate">Date<input id="edate" type="date" min="${min}" value="${esc(A.eventDate||"")}"></label>
    <button class="btn" id="cta" ${A.eventDate?"":"disabled"}>Continue</button>
    <button class="link" id="skip">Skip this step</button>`;
}

/* ---------- scoring ---------- */
function score(){
  let p = 0;
  const age=A.age||"";
  if (age==="50–59") p+=1; if (age==="60–69") p+=2; if (age==="70 or older") p+=3;
  const c=(A.concerns||[]).filter(x=>!x.startsWith("Nothing yet") && x!==CHEST); p+=Math.min(c.length,3);
  p += ({"Just starting":0,"Clearly there":1,"Hard to ignore":2})[A.severity]||0;
  const sg=(A.signs||[]).filter(x=>x!=="None of these"); p+=Math.min(sg.length,3);
  p += ({"Mostly sitting":2,"Somewhat active":1})[A.activity]||0;
  p += ({"Every day, constantly":2,"Most days, especially at work":1})[A.stress]||0;
  if ((A.family||"").startsWith("Yes")) p += A.family==="Yes, more than one person"?3:2;
  return p;
}
function level(p){ return p>=11?3 : p>=7?2 : p>=4?1 : 0; }
const LEVELS=["Low","Moderate","Elevated","High"];
function focus(){
  const c=(A.concerns||[]).filter(x=>x!==CHEST)[0]||"";
  if (c.startsWith("My blood pressure")) return "Healthy blood pressure";
  if (c.startsWith("My cholesterol")) return "Arterial health";
  if (c.startsWith("Low energy")) return "Cellular energy";
  if (c.startsWith("Cold hands")||c.startsWith("I tire")) return "Blood flow and circulation";
  if (c.startsWith("Heart problems")) return "Arterial health";
  return "All-around heart support";
}
function factors(){
  const f=[];
  if (["Every day, constantly","Most days, especially at work"].includes(A.stress)) f.push("daily stress");
  if (A.activity==="Mostly sitting") f.push("too much sitting");
  if ((A.family||"").startsWith("Yes")) f.push("family history");
  if ((A.signs||[]).includes("Short or restless sleep")) f.push("short sleep");
  if (["60–69","70 or older"].includes(A.age)) f.push("age");
  return f;
}
const list = a => a.length<=1 ? (a[0]||"") : a.slice(0,-1).join(", ")+" and "+a[a.length-1];

function renderProfile(){
  const lv=level(score()), f=factors();
  const left=[12.5,37.5,62.5,87.5][lv];
  const why = f.length
    ? `Your answers point to ${list(f.slice(0,3))} putting extra demand on your heart every day. That makes consistent daily support a priority for you.`
    : `You're ahead of most people your age. The best time to build heart habits is before you need them.`;
  return `<div class="kicker">${first()?esc(first())+"'s ":"Your "}Heart Longevity Profile</div>
    <h2>Your heart support priority is <span style="color:var(--wine)">${LEVELS[lv]}</span></h2>
    <div class="card stack">
      <div class="gauge"><div class="gauge-pin" style="left:${left}%">You</div>
        <div class="gauge-bar"><span></span><span></span><span></span><span></span></div>
        <div class="gauge-labels">${LEVELS.map(l=>`<span>${l}</span>`).join("")}</div></div>
      <p>${why}</p>
    </div>
    <div class="tiles">
      <div class="tile"><small>Main focus</small><strong>${focus()}</strong></div>
      <div class="tile"><small>Biggest factor</small><strong>${f.length? f[0][0].toUpperCase()+f[0].slice(1) : "Staying consistent"}</strong></div>
      <div class="tile"><small>Family history</small><strong>${(A.family||"").startsWith("Yes")?"Yes":A.family==="No"?"None reported":"Unknown"}</strong></div>
      <div class="tile"><small>Room to improve</small><strong>${lv>=1?"High":"Moderate"}</strong></div>
    </div>
    <p class="fine">This profile is based on your lifestyle answers. It is not a medical test or diagnosis.</p>
    <button class="btn" id="cta">See my 90-day plan</button>`;
}

function daysUntil(d){ if(!d) return null; const t=new Date(d+"T12:00:00"); const n=new Date(); return Math.ceil((t-n)/864e5); }
function fmtDate(d){ try{ return new Date(d+"T12:00:00").toLocaleDateString("en-US",{month:"long",day:"numeric"});}catch(e){return d;} }

function renderPlan(){
  const name=first();
  const bt = A.meds==="A blood thinner"||A.meds==="Both";
  const signs=(A.signs||[]);
  const nowEnergy = signs.includes("Afternoon energy crash")||(A.concerns||[]).some(c=>c.startsWith("Low energy")) ? "Crashing by afternoon" : "Inconsistent";
  const nowFlow = signs.includes("Cold hands or feet")||signs.includes("Winded on stairs or long walks") ? "Needs support" : "Unsupported";
  const dleft = daysUntil(A.eventDate);
  const eventLine = (A.eventDate && dleft>0)
    ? `<div class="banner">Your ${esc(A.event.replace(/^A |^My /,"").toLowerCase())} is on ${fmtDate(A.eventDate)}, ${dleft} days away. Start today and you'll be ${dleft>=90?"through the full program":"on Day "+dleft+" of your program"} by then.</div>` : "";
  const utm = "?utm_source=heart_quiz&utm_medium=quiz&utm_campaign=launch";
  return `<div class="kicker">Based on your answers</div>
    <div class="submit-status" id="klaviyo-save-status" aria-live="polite"></div>
    <h2>${name?esc(name)+", you're":"You're"} 90 days away from a stronger daily heart routine</h2>
    ${eventLine}
    <div class="gift">
      <div class="kicker" style="color:var(--gold-soft)">Free gift for you</div>
      <strong>We're giving you the 90-Day Heart Longevity Program completely free.</strong>
      <p>A CORVIA heart coach may call you at <b>${esc(lead.phone)}</b> to discuss your Heart Check and next steps. Please keep your phone nearby.</p>
    </div>
    <div class="card stack">
      <strong style="font-family:var(--display);font-size:21px;color:var(--wine-deep)">Why the CORVIA capsule is different</strong>
      <p style="color:var(--muted)">Most heart supplements give you one ingredient for one part of the system. CORVIA supports four connected pathways in one daily capsule.†</p>
      <div class="vs">
        <div class="col them"><h3>Typical supplement</h3><ul><li>One or two ingredients</li><li>Supports one pathway</li><li>Doses hidden in a proprietary blend</li><li>No plan to follow</li></ul></div>
        <div class="col us"><h3>CORVIA</h3><ul><li>Six complementary ingredients</li><li>Four pathways: blood pressure, blood flow, arteries, cellular energy†</li><li>Every dose on the label</li><li>Free 90-Day Program</li></ul></div>
      </div>
    </div>
    <div class="compare">
      <div class="col now"><h3>Now</h3><dl>
        <div><dt>Energy</dt><dd>${nowEnergy}</dd></div>
        <div><dt>Blood flow</dt><dd>${nowFlow}</dd></div>
        <div><dt>Heart habits</dt><dd>No set plan</dd></div></dl></div>
      <div class="col goal"><h3>Day 90 goal</h3><dl>
        <div><dt>Energy</dt><dd>Steady, all day</dd></div>
        <div><dt>Blood flow</dt><dd>Supported daily</dd></div>
        <div><dt>Heart habits</dt><dd>A routine you keep</dd></div></dl></div>
    </div>
    <div class="card stack">
      <strong style="font-family:var(--display);font-size:21px;color:var(--wine-deep)">Your 90-day path</strong>
      <div class="timeline">
        <div><b>Day 1</b><span>First capsule and first program lesson</span></div>
        <div><b>Week 2</b><span>Your daily routine is in place</span></div>
        <div><b>Day 30</b><span>Nutrition and movement actions</span></div>
        <div><b>Day 60</b><span>Sleep and stress actions</span></div>
        <div><b>Day 90</b><span>Your full heart longevity routine</span></div>
      </div>
    </div>
    ${(A.concerns||[]).includes(CHEST)?`<div class="note"><b>About your chest pain:</b> please have a doctor check it before starting any new supplement, CORVIA included.</div>`:""}
    ${bt?`<div class="note"><b>Before you order:</b> you told us you take a blood thinner. Please talk to your doctor before starting CORVIA, since nattokinase and aged garlic extract can affect clotting.</div>`:""}
    <h2 style="font-size:24px">Your Heart Longevity Launch pricing</h2>
    <div class="offers">
      <a class="offer best" href="${PRODUCT_URL+utm}&utm_content=90day" target="_blank" rel="noopener"><span class="tag">Best value · matches your 90-day plan</span>
        <span><b>90-day supply</b></span><span class="px"><b>$39</b>/bottle<s>$59/bottle</s></span>
        <small>3 bottles · $117 total · you save $60</small></a>
      <a class="offer" href="${PRODUCT_URL+utm}&utm_content=60day" target="_blank" rel="noopener">
        <span><b>60-day supply</b></span><span class="px"><b>$49</b>/bottle<s>$59/bottle</s></span>
        <small>2 bottles · $98 total</small></a>
      <a class="offer" href="${PRODUCT_URL+utm}&utm_content=30day" target="_blank" rel="noopener">
        <span><b>30-day supply</b></span><span class="px"><b>$59</b>/bottle</span>
        <small>1 bottle</small></a>
    </div>
    <a class="btn gold" href="${PRODUCT_URL+utm}&utm_content=cta" target="_blank" rel="noopener">Claim my launch pricing</a>
    <div class="trust"><div>90-day money-back guarantee</div><div>Third-party tested</div><div>Made in the USA</div></div>
    <p class="disc">† These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. This quiz is for general wellness education and is not medical advice. If you have chest pain, fainting, or shortness of breath at rest, contact a doctor or call 911.</p>`;
}

/* ---------- Klaviyo profile save ---------- */
// Klaviyo profile capture is enabled only when BOTH IDs are configured in the Shopify section.
// Both the Public Site ID and Email List ID are required for profile capture and email subscription.
const KLAVIYO_ENABLED = Boolean(KLAVIYO_PUBLIC_KEY && KLAVIYO_LIST_ID);

function buildKlaviyoQuizData(status){
  const questionAnswers = S
    .filter(step => Object.prototype.hasOwnProperty.call(A, step.id))
    .map(step => ({
      question_id: step.id,
      question: step.q || step.id,
      answer: A[step.id]
    }));

  const data = {
    // Stable segment marker: use this to include every contact-form submission,
    // including people who leave before finishing the quiz.
    Heart_Check_Lead: true,
    Heart_Check_Lead_Captured_At: quizStartedAt || new Date().toISOString(),
    Heart_Check_Consio_Ready: Boolean(normalizeKlaviyoPhone(lead.phone)),
    Heart_Check_Status: status,
    Heart_Check_Completed: status === "completed",
    Heart_Check_Started_At: quizStartedAt || new Date().toISOString(),
    Heart_Check_Source: "CORVIA Heart Check V2",
    Heart_Check_Questions_And_Answers: questionAnswers,
    Heart_Check_Answers_By_ID: { ...A }
  };

  // Do not write a score/result until the customer has reached the results screen.
  const profileIndex = S.findIndex(step => step.id === "profile");
  if (i >= profileIndex) {
    data.Heart_Check_Result = {
      score: score(),
      level: LEVELS[level(score())],
      focus: focus(),
      factors: factors()
    };
  }

  if (status === "completed") {
    quizCompletedAt = quizCompletedAt || new Date().toISOString();
    data.Heart_Check_Completed_At = quizCompletedAt;
  }

  return data;
}

function normalizeKlaviyoPhone(rawPhone){
  // CORVIA accepts US national numbers only.
  // Klaviyo's phone_number field must use E.164: +1 followed by 10 digits.
  const digits = String(rawPhone || "").replace(/\D/g, "");
  if (digits.length !== 10) return "";
  return "+1" + digits;
}

function queueKlaviyoSave(status){
  if (!KLAVIYO_ENABLED || !lead.email) return Promise.resolve(false);

  const attributes = {
    email: lead.email,
    first_name: lead.name,
    properties: buildKlaviyoQuizData(status)
  };

  const phoneNumber = normalizeKlaviyoPhone(lead.phone);
  // Klaviyo's standard phone_number field is what downstream integrations
  // such as Consio can use as the contact's callable number.
  if (phoneNumber) attributes.phone_number = phoneNumber;

  // Diagnostic only: log presence/format validity, never the customer's number.
  console.info("[CORVIA Heart Check V2] Klaviyo payload:", {
    emailPresent: Boolean(attributes.email),
    phoneNumberIncluded: Boolean(attributes.phone_number),
    phoneNumberFormatValid: Boolean(phoneNumber && /^\+1\d{10}$/.test(phoneNumber)),
    requestType: klaviyoSubscriptionComplete ? "profile_update" : "initial_subscription"
  });

  const profileRequestBody = {
    data: {
      type: "profile",
      attributes
    }
  };

  // First request creates/updates the profile and subscribes it to the configured email list.
  // Later requests only update profile properties, avoiding repeated subscription requests.
  const subscriptionRequestBody = {
    data: {
      type: "subscription",
      attributes: {
        custom_source: "CORVIA Heart Check V2",
        profile: {
          data: {
            type: "profile",
            attributes: {
              ...attributes,
              subscriptions: {
                email: {
                  marketing: {
                    consent: "SUBSCRIBED"
                  }
                }
              }
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: "list",
            id: KLAVIYO_LIST_ID
          }
        }
      }
    }
  };

  // Serialize requests so a slower earlier save cannot overwrite a newer quiz snapshot.
  klaviyoQueue = klaviyoQueue
    .catch(() => false)
    .then(async () => {
      const isSubscriptionRequest = !klaviyoSubscriptionComplete;
      const endpoint = isSubscriptionRequest
        ? "https://a.klaviyo.com/client/subscriptions?company_id="
        : "https://a.klaviyo.com/client/profiles?company_id=";
      const requestBody = isSubscriptionRequest
        ? subscriptionRequestBody
        : profileRequestBody;

      const response = await fetch(
        endpoint + encodeURIComponent(KLAVIYO_PUBLIC_KEY),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            "Accept": "application/vnd.api+json",
            "revision": "2026-10-15"
          },
          body: JSON.stringify(requestBody)
        }
      );

      if (!response.ok && response.status !== 202) {
        const details = await response.text().catch(() => "");
        throw new Error("Klaviyo " + (isSubscriptionRequest ? "subscription" : "profile save") +
          " failed (" + response.status + "): " + details);
      }

      // Klaviyo may accept the email subscription (202) but partially reject
      // phone_number. Do not silently treat that as a successful phone capture.
      const partialFailure = response.headers.get("X-Klaviyo-Partial-Failure") || "";
      if (partialFailure.toLowerCase().includes("phone_number")) {
        throw new Error(
          "Klaviyo partially rejected phone_number. Confirm the number is a real, active US number and is sent as +1 followed by 10 digits. Partial failure: " +
          partialFailure
        );
      }

      if (isSubscriptionRequest) klaviyoSubscriptionComplete = true;

      const statusEl = root.querySelector("#klaviyo-save-status");
      if (statusEl) {
        statusEl.textContent = status === "completed"
          ? "Your Heart Check profile has been saved."
          : "";
      }
      return true;
    })
    .catch(error => {
      console.error("[CORVIA Heart Check V2] Klaviyo save:", error);
      const statusEl = root.querySelector("#klaviyo-save-status");
      if (statusEl && status === "completed") {
        statusEl.textContent = error.message.includes("partially rejected phone_number")
          ? "Your email and quiz details were received, but Klaviyo rejected the phone number. Please check that it is a real, active 10-digit US number."
          : "Your results are ready. We couldn't save your profile to Klaviyo.";
      }
      // Never block the customer from continuing if Klaviyo is temporarily unavailable.
      // If subscription fails, the next quiz save will retry the subscription request.
      return false;
    });

  return klaviyoQueue;
}

/* ---------- wiring ---------- */
function wire(s){
  const cta = root.querySelector("#cta");
  if (s.type==="single"){
    let busy=false;
    app.querySelectorAll(".opt").forEach(b=>b.addEventListener("click",()=>{
      if (busy) return; busy=true;
      A[s.id]=b.dataset.v;
      app.querySelectorAll(".opt").forEach(x=>{const on=x===b; x.setAttribute("aria-pressed",on); x.querySelector(".mk").textContent=on?"✓":"";});
      setTimeout(next,220);
    }));
  }
  if (s.type==="multi"){
    app.querySelectorAll(".opt").forEach(b=>b.addEventListener("click",()=>{
      let cur=A[s.id]||[]; const v=b.dataset.v;
      if (cur.includes(v)) cur=cur.filter(x=>x!==v);
      else if (s.none && v===s.none) cur=[v];
      else cur=cur.filter(x=>x!==s.none).concat(v);
      A[s.id]=cur;
      app.querySelectorAll(".opt").forEach(x=>{const on=cur.includes(x.dataset.v); x.setAttribute("aria-pressed",on); x.querySelector(".mk").textContent=on?"✓":"";});
      cta.disabled=!cur.length;
    }));
    cta.addEventListener("click",next);
  }
  if (s.type==="info" || s.type==="profile") cta.addEventListener("click",next);
  if (s.type==="auto"){
    const bar=root.querySelector("#autobar");
    requestAnimationFrame(()=>{bar.style.transition="width 2.6s linear"; bar.style.width="100%";});
    timer=setTimeout(next,2800);
  }
  if (s.type==="loader"){
    const bar=root.querySelector("#lbar"), ls=app.querySelectorAll(".lsteps div");
    requestAnimationFrame(()=>{bar.style.transition="width 3.2s ease"; bar.style.width="100%";});
    ls.forEach((d,k)=>setTimeout(()=>d.classList.add("on"),300+k*1000));
    timer=setTimeout(next,3500);
  }
  if (s.type==="date"){
    const inp=root.querySelector("#edate");
    inp.addEventListener("input",()=>{A.eventDate=inp.value; cta.disabled=!inp.value;});
    cta.addEventListener("click",()=>{ next(); });
    root.querySelector("#skip").addEventListener("click",()=>{A.eventDate=""; next();});
  }
  
  if (s.type==="gate"){
    const f=root.querySelector("#gf"), err=root.querySelector("#gerr");
    const phoneInput = root.querySelector("#gphone");

    // Strip letters and punctuation immediately, including pasted content.
    phoneInput.addEventListener("input", () => {
      const digitsOnly = phoneInput.value.replace(/\D/g, "").slice(0, 10);
      if (phoneInput.value !== digitsOnly) phoneInput.value = digitsOnly;
    });

    f.addEventListener("submit", e=>{
      e.preventDefault();
      const n=root.querySelector("#gname").value.trim();
      const m=root.querySelector("#gemail").value.trim();
      const ph=root.querySelector("#gphone").value.trim();

      if (!n){ err.textContent="Please enter your first name."; return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(m)) {
        err.textContent="Please enter a valid email address.";
        return;
      }
      const digits=ph.replace(/\D/g,"");
      if (digits.length !== 10){
        err.textContent="Please enter a valid 10-digit US phone number.";
        return;
      }

      lead={name:n,email:m,phone:digits};
      quizStartedAt = quizStartedAt || new Date().toISOString();
      err.textContent="";

      // Save the contact and all answers collected before the gate immediately.
      // Quiz progression is not blocked if Klaviyo is unavailable.
      queueKlaviyoSave("started");
      next();
    });
  }}

render();
})();
